export default "__VITE_ASSET__V$ipaa8p__"